require("bootstrap-sass/assets/javascripts/bootstrap/alert");
require("bootstrap-sass/assets/javascripts/bootstrap/button");
require("bootstrap-sass/assets/javascripts/bootstrap/carousel");
require("bootstrap-sass/assets/javascripts/bootstrap/collapse");
require("bootstrap-sass/assets/javascripts/bootstrap/dropdown");
// require("bootstrap-sass/assets/javascripts/bootstrap/modal");
require("bootstrap-sass/assets/javascripts/bootstrap/tab");
// require("bootstrap-sass/assets/javascripts/bootstrap/affix");
// require("bootstrap-sass/assets/javascripts/bootstrap/scrollspy");
// require("bootstrap-sass/assets/javascripts/bootstrap/popover");
// require("bootstrap-sass/assets/javascripts/bootstrap/tooltip");
require("bootstrap-sass/assets/javascripts/bootstrap/transition");
